import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { Observable, of } from "rxjs";
import { TribalAffilationService } from "../../shared/services/tribal-affilation.service";
import { TribalAffilationResponse } from "../../shared/models/tribal-affilation.model";

@Injectable({
    providedIn: 'root',
})
export class GetTribalAffilationResolver implements Resolve<TribalAffilationResponse[]> {

    constructor(
        private tribalAffilationService: TribalAffilationService,
    ) { }

    resolve(): Observable<TribalAffilationResponse[]> {
        return this.tribalAffilationService.getAll();
    }
}
